// Per-language Spotify show URLs.
// Fill in URLs as each language's podcast goes live on Spotify. The UI
// automatically swaps between a "Listen on Spotify" button and a
// "Coming soon — notify me" callout based on whether a URL is present.
export const SPOTIFY_SHOWS = {
  en: "https://open.spotify.com/show/033ANa3AS9zK9OSMJOU4oo",
  de: null,
  fr: null,
  es: null,
  it: null,
  el: null,
  tr: null,
  ar: null,
  nl: null,
  ru: null,
  zh: null,
  hi: null,
};

export function spotifyUrlFor(code) {
  return SPOTIFY_SHOWS[code] || null;
}
